import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import * as GrIcons from "react-icons/gr";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const variants = {
  enter: (direction: number) => {
    return {
      x: direction < 0 ? 1000 : -1000,
      opacity: 0,
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1,
  },
};

import mtekLogo  from "../../../assets/images/mtek-logo.svg"


function liabilityClaim({ setCurrentScreen }: any) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [liabilityInfo, setLiabilityInfo] = useState({
    startDate: "",
    endDate: "",
    apartmentName: "",
    apartmentPoBox: "",
    apartmentPostalAddress: "",
    details: "",
  });
  useEffect(() => {
    setCurrentScreen("claim-liability");
    sessionStorage.setItem("claim-screens", "claim-liability");
  });

  const handleInputChange = (event: any) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    setLiabilityInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const saveDetails = () => {
    if (!liabilityInfo.startDate) {
      document.getElementById("startDate")?.focus;
      toast.warning(t("liabilityClaim.enterStartDate"));
      return;
    }
    if (!liabilityInfo.endDate) {
      document.getElementById("endDate")?.focus;
      toast.warning(t("liabilityClaim.enterEndDate"));
      return;
    }
    if (!liabilityInfo.apartmentName) {
      document.getElementById("apartmentName")?.focus;
      toast.warning(t("liabilityClaim.enterApartmentName"));
      return;
    }
    if (!liabilityInfo.apartmentPoBox) {
      document.getElementById("apartmentPoBox")?.focus;
      toast.warning(t("liabilityClaim.enterApartmentPoBox"));
      return;
    }
    if (!liabilityInfo.apartmentPostalAddress) {
      document.getElementById("startDate")?.focus;
      toast.warning(t("liabilityClaim.enterApartmentPostalAddress"));
      return;
    }
    if (!liabilityInfo.details) {
      document.getElementById("details")?.focus;
      toast.warning(t("liabilityClaim.enterDetails"));
      return;
    }
    setCurrentScreen("claim-documents");
    sessionStorage.setItem("claims-back", "claim-liability");
    sessionStorage.setItem("claim-screens", "claim-documents");
    sessionStorage.setItem("claimInfo", JSON.stringify(liabilityInfo));
    sessionStorage.setItem("claim_type", "Personal Liability Claim");
  };
  return (
    <div className="container">
      <motion.div
        variants={variants}
        initial="enter"
        animate="center"
        exit={{ opacity: 0 }}
        className="steps-conatiner2"
      >
        <div
          className="image text-center mt-5 mb-3"
          onClick={() => navigate("/")}
        >
          <img src={mtekLogo} alt="travel icon" />
        </div>
        <div className="reg-title text-center mb-4">
          <span>
            {t("liabilityClaim.provideDetailsHeader")}
          </span>{" "}
          <span className="span-title">{t("liabilityClaim.claimTitle")}</span>   
        </div>
        <div className="cancellation-input">
          <div className="ky-inputs-inner-container">
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container ky-input-container-claim mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="startDate">
                  {t("liabilityClaim.incidentDateLabel")}
                </label>
                <br />
                <div className="postal-area-container">
                  <input
                    id="startDate"
                    name="startDate"
                    type="date"
                    onChange={handleInputChange}
                    value={liabilityInfo.startDate}
                  ></input>

                  <input
                    id="endDate"
                    name="endDate"
                    type="date"
                    onChange={handleInputChange}
                    value={liabilityInfo.endDate}
                  ></input>
                </div>
              </motion.div>
            </div>
            <div className="ky-input-wrapper">
              <motion.div
                animate={{ scale: [-0.7, 1] }}
                transition={{ duration: 1 }}
                className="ky-input-container mt-4"
              >
                <label className="text-left-label mb-2" htmlFor="postal">
                  {t("liabilityClaim.apartmentLabel")}{" "}
                </label>
                <br />
                <div className="apartment-input" style={{ width: "100%" }}>
                  <input
                    id="apartmentName"
                    name="apartmentName"
                    type="text"
                    onChange={handleInputChange}
                    value={liabilityInfo.apartmentName}
                    placeholder={t("liabilityClaim.namePlaceholder")}
                  ></input>
                </div>
                <div className="postal-area-container mt-2">
                  <input
                    id="apartmentPoBox"
                    name="apartmentPoBox"
                    type="text"
                    onChange={handleInputChange}
                    value={liabilityInfo.apartmentPoBox}
                    placeholder={t("liabilityClaim.poBoxPlaceholder")}
                  ></input>

                  <input
                    id="apartmentPostalAddress"
                    name="apartmentPostalAddress"
                    type="text"
                    onChange={handleInputChange}
                    value={liabilityInfo.apartmentPostalAddress}
                    placeholder={t("liabilityClaim.postalCodePlaceholder")}
                  ></input>
                </div>
              </motion.div>
            </div>
          </div>
          <div className="ky-input-wrapper mb-5" style={{ width: "100%" }}>
            <motion.div
              animate={{ scale: [-0.7, 1] }}
              transition={{ duration: 1 }}
              className="ky-input-container ky-input-container-claim mt-4"
            >
              <label className="text-left-label mb-2" htmlFor="details">
                {t("liabilityClaim.detailsLabel")}
              </label>
              <br />
              <input
                id="details"
                name="details"
                type="text"
                onChange={handleInputChange}
                value={liabilityInfo.details}
                placeholder={t("liabilityClaim.typeHere")}
              ></input>
            </motion.div>
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <div className="previous">
            <span
              onClick={(e) => {
                sessionStorage.setItem("claim-screens", "claim-options");
                setCurrentScreen("claim-options");
              }}
            >
              <span className="GrIcon me-2">
                <GrIcons.GrFormPreviousLink />
              </span>{" "}
              <span className="previous">{t("liabilityClaim.previous")}</span>
            </span>
          </div>
          <div className="mt-5" onClick={() => saveDetails()}>
            <button className="pointer-btn next-btn">
              {" "}
              <span>
                {t("liabilityClaim.proceed")}{" "}
                <span className="GrIcon ms-3">
                  <GrIcons.GrFormNextLink />
                </span>
              </span>{" "}
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default liabilityClaim;
